import { apiURL } from './constants';
import axios from 'axios';

function authHeaders() {
  axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
}

/**
 * GET /api/pricing/settlement-groups/
 * Permission: settlement_groups_list
 * Filters: active, separate_checkout, search, ordering, page, page_size
 */
export async function listSettlementGroups(params = {}) {
  authHeaders();
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      searchParams.append(k, v);
    }
  });
  const q = searchParams.toString();
  const url = `${apiURL}/api/pricing/settlement-groups/${q ? `?${q}` : ''}`;
  return axios.get(url, { withCredentials: true });
}

/**
 * GET /api/pricing/settlement-groups/{id}/
 * Permission: settlement_groups_view
 */
export async function getSettlementGroup(id) {
  authHeaders();
  return axios.get(`${apiURL}/api/pricing/settlement-groups/${id}/`, { withCredentials: true });
}

/**
 * POST /api/pricing/settlement-groups/
 * Permission: settlement_groups_create
 */
export async function createSettlementGroup(data) {
  authHeaders();
  return axios.post(`${apiURL}/api/pricing/settlement-groups/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * PUT /api/pricing/settlement-groups/{id}/
 * Permission: settlement_groups_update
 */
export async function updateSettlementGroup(id, data) {
  authHeaders();
  return axios.put(`${apiURL}/api/pricing/settlement-groups/${id}/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * PATCH /api/pricing/settlement-groups/{id}/
 * Permission: settlement_groups_update
 */
export async function patchSettlementGroup(id, data) {
  authHeaders();
  return axios.patch(`${apiURL}/api/pricing/settlement-groups/${id}/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * DELETE /api/pricing/settlement-groups/{id}/
 * Soft-delete. Cannot delete code=default.
 * Permission: settlement_groups_delete
 */
export async function deleteSettlementGroup(id) {
  authHeaders();
  return axios.delete(`${apiURL}/api/pricing/settlement-groups/${id}/`, { withCredentials: true });
}
